/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { getRequest, patchRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';

const UpdateProgram = () => {
    const { id } = useParams();
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        benefits: '',
        eligibility: '',
        guidelines: '',
        is_active: true,
        image: null
    });
    const [existingImage, setExistingImage] = useState('');
    const [loading, setLoading] = useState(false);
    const [fetching, setFetching] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchProgramDetails = async () => {
            try {
                const res = await getRequest(`programs/${id}?all=true`);
                const data = res?.data;
                if (data) {
                    setFormData({
                        title: data.title || '',
                        description: data.description || '',
                        benefits: data.benefits || '',
                        eligibility: data.eligibility || '',
                        guidelines: data.guidelines || '',
                        is_active: data.is_active,
                        image: null
                    });
                    setExistingImage(data.image);
                }
            } catch (err) {
                console.error(err);
                toast.error("Failed to load program details.");
            } finally {
                setFetching(false);
            }
        };

        fetchProgramDetails();
    }, [id]);

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'file' ? e.target.files[0] : value
        }));
    };

    const handleSelectChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value === 'true'
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const data = new FormData();
        data.append('title', formData.title);
        data.append('description', formData.description);
        data.append('benefits', formData.benefits);
        data.append('eligibility', formData.eligibility);
        data.append('guidelines', formData.guidelines);
        data.append('is_active', formData.is_active);
        
        if (formData.image) {
            data.append('image', formData.image);
        }

        try {
            await patchRequest(`programs/${id}`, data);
            toast.success('Program updated successfully!');
            navigate('/programs');
        } catch (error) {
            console.error('Failed to update program:', error);
            toast.error(error?.message || 'Error occurred while updating program.');
        } finally {
            setLoading(false);
        }
    };

    if (fetching) {
        return (
            <div className="text-center my-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className='container-fluid mt-5 mb-5'>
                <div className='mainheadig mx-4 mb-4'>
                    <h4 className='text-white font-weight-bold'>Update Incubation Program</h4>
                </div>
                <form onSubmit={handleSubmit} className="mx-4 p-4 card shadow">
                    <div className='row'>
                        <div className='col-sm-12 form-group'>
                            <label className='admin-label font-weight-bold'>Program Title *</label>
                            <input
                                type='text'
                                name='title'
                                className='form-control'
                                value={formData.title}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className='col-sm-12 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>Description *</label>
                            <textarea
                                name='description'
                                className='form-control'
                                rows="4"
                                value={formData.description}
                                onChange={handleChange}
                                required
                            ></textarea>
                        </div>

                        <div className='col-sm-12 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>Program Benefits</label>
                            <textarea
                                name='benefits'
                                className='form-control'
                                rows="3"
                                value={formData.benefits}
                                onChange={handleChange}
                            ></textarea>
                        </div>

                        <div className='col-sm-12 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>Eligibility Criteria</label>
                            <textarea
                                name='eligibility'
                                className='form-control'
                                rows="3"
                                value={formData.eligibility}
                                onChange={handleChange}
                            ></textarea>
                        </div>

                        <div className='col-sm-12 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>Application Guidelines</label>
                            <textarea
                                name='guidelines'
                                className='form-control'
                                rows="3"
                                value={formData.guidelines}
                                onChange={handleChange}
                            ></textarea>
                        </div>

                        <div className='col-sm-6 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>Status</label>
                            <select
                                name="is_active"
                                className="form-control"
                                value={formData.is_active ? "true" : "false"}
                                onChange={handleSelectChange}
                            >
                                <option value="true">Active</option>
                                <option value="false">Inactive</option>
                            </select>
                        </div>

                        <div className='col-sm-12 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>Replace Image</label>
                            <input
                                type='file'
                                name='image'
                                className='form-control filebg'
                                onChange={handleChange}
                                accept="image/*"
                            />
                            {existingImage && !formData.image && (
                                <div className="mt-2">
                                    <small className="text-muted d-block">Current Image:</small>
                                    <img
                                        src={`${process.env.REACT_APP_BACKEND}uploads/${existingImage}`}
                                        alt="existing"
                                        width={100}
                                        style={{ borderRadius: '4px', marginTop: '5px' }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    
                    <div className='mt-4 text-right'>
                        <button
                            type="button"
                            className="btn btn-secondary mr-2"
                            onClick={() => navigate('/programs')}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className='btn addbtn pl-4 pr-4'
                            disabled={loading}
                        >
                            {loading ? 'Updating...' : 'Update Program'}
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default UpdateProgram;
